'use client';

/**
 * SysObeyaKpiCohesionAvgCard — Procedural Patterns KPI tile.
 *
 * Slices `response.totals.{avg_procedural_score,
 * highest_procedural_score}` from the system_obeya_view cohesion call.
 * Hero number is the average procedural score across flagged classes;
 * sub-label shows the single worst score ("max 0.88").
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_cohesion_avg"
 * @see klyde_edge/ui_config/labels/system_obeya.py — cohesion_kpi_avg_*
 */

import { Gauge } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiCohesionAvgCard({ view_name = 'cohesion' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  const highest = t.highest_procedural_score;
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_cohesion_avg"
      label={L.cohesion_kpi_avg_score_label ?? ''}
      Icon={Gauge}
      value={isLoading ? '…' : fmt(t.avg_procedural_score)}
      sub={highest != null ? `${L.cohesion_kpi_avg_sub_prefix ?? ''}${fmt(highest)}` : undefined}
      queryKey={queryKey}
    />
  );
}
